import apiFetch, { ApiFetchOptions } from '@scale/frontend-lib/api-fetch';
import authFetch from '@scale/frontend-lib/auth-fetch';
import {
  FetchReviewerCopilotInferenceRequest,
  FetchReviewerCopilotInferenceResponse,
  AutoCritiqueRequest,
  AutoCritiqueResponse,
  RunResponseLinterRequest,
  RunMultiReplicaStepResponseLinterRequest,
  RunResponseLinterResponse,
  FetchCorpDialoguesResponse,
  SaveCorpDialogueRequest,
  SaveCorpDialogueResponse,
  UpdateCorpDialogueResponse,
  UpdateCorpDialogueRequest,
  DeleteCorpDialogueRequest,
  DeleteCorpDialogueResponse,
  RunPerStepResponseLinterRequest,
  RunPerStepResponseLinterResponse,
  RunMultiReplicaStepResponseLinterResponse,
  UpdateProjectConfigRequest,
  UpdateProjectConfigResponse,
  LinterStatsRequest,
  LinterStatsResponse,
  GetDowngradedLintersRequest,
  GetDowngradedLintersResponse,
  FetchWorkerCommentsRequest,
  FetchWorkerCommentsResponse,
  AddWorkerCommentRequest,
  AddWorkerCommentResponse,
  BulkAddWorkerCommentsRequest,
  BulkAddWorkerCommentsResponse,
  AddFeedbackToWorkerCommentRequest,
  AddFeedbackToWorkerCommentResponse,
  BulkAddFeedbackToWorkerCommentsRequest,
  BulkAddFeedbackToWorkerCommentsResponse,
  FetchWorkerCommentsForTaskAttemptRequest,
  FetchWorkerCommentsForTaskAttemptResponse,
  AddAttemptFeedbackRequest,
  AddAttemptFeedbackResponse,
  FetchAttemptFeedbackRequest,
  FetchAttemptFeedbackResponse,
  SendReviewerCopilotFeedbackRequest,
  SendReviewerCopilotFeedbackResponse,
  FetchContributorFeedbackForStepRequest,
  FetchContributorFeedbackForStepResponse,
  FetchContributorFeedbackForAttemptRequest,
  FetchContributorFeedbackForAttemptResponse,
  GenerateUnitTestsRequest,
  GenerateUnitTestsResponse,
  RunUnitTestsRequest,
  RunUnitTestsResponse,
  GetHiddenUnitTestsFromTaskMetadataRequest,
  GetHiddenUnitTestsFromTaskMetadataResponse,
  AutoraterJustificationSuggestionRequest,
  AutoraterJustificationSuggestionsResponse,
  AutoraterLikertJustificationSuggestionRequest,
  AutoraterLikertJustificationSuggestionsResponse,
} from '@scale/shared/types/chat';
import {
  ReviewScreeningWithScoreRequest,
  ScreeningPendingReviewResponse,
  ReviewScreeningWithScoreResponse,
  PublishScreeningBenchmarkRequest,
  PublishScreeningBenchmarkResponse,
  PublishBulkScreeningBenchmarkRequest,
  PublishBulkScreeningBenchmarkResponse,
  FetchScreeningBenchmarkRequest,
  FetchScreeningBenchmarkResponse,
  UpdateScreeningBenchmarkEnabledRequest,
  UpdateScreeningBenchmarkEnabledResponse,
  FetchAuditorEvaluationRequest,
  FetchAuditorEvaluationResponse,
  PublishAuditPermissionRoleRequest,
  PublishAuditPermissionRoleResponse,
  FetchAuditPermissionsRequest,
  FetchAuditPermissionsResponse,
  UpdateAuditorPermissionsRequest,
  UpdateAuditorPermissionsResponse,
  UpdatePermissionBenchmarkSettingsRequest,
  UpdatePermissionBenchmarkSettingsResponse,
  FetchScreeningBenchmarkPermissionsInfoRequest,
  FetchScreeningBenchmarkPermissionsInfoResponse,
  UpdateScreeningBenchmarkPermissionsRequest,
  UpdateScreeningBenchmarkPermissionsResponse,
  ScreeningPendingReviewRequest,
  UpdatePermissionFiltersRequest,
  UpdatePermissionFiltersResponse,
  PurgeScreeningsRequest,
  PurgeScreeningsResponse,
  SbqScreeningsRequest,
  SbqScreeningsResponse,
  FetchUniqueSectionTitlesResponse,
  UpdateAuditPermissionRoleRequest,
  ArchiveAuditPermissionRoleRequest,
  ArchiveAuditPermissionRoleResponse,
} from '@scale/shared/taskerScreening/types';
import {
  BenchmarkCandidateResponse,
  BulkBenchmarkCandidateResponse,
} from '@scale/shared/types/benchmarkDataBank/api';
import {
  GetStellarGenAITasksByProjectParams,
  GetStellarGenAITasksByProjectQuery,
  GetStellarGenAITasksByProjectRespBody,
  GetStellarGenAITaskByAttemptParams,
  GetStellarGenAITaskByAttemptRespBody,
  GetStellarGenAITaskEligibilityParams,
  GetStellarGenAITaskEligibilityRespBody,
  CreateStellarGenAITaskReqBody,
  CreateStellarGenAITaskRespBody,
  UpdateStellarGenAITaskParams,
  UpdateStellarGenAITaskReqBody,
  UpdateStellarGenAITaskRespBody,
  SetAnnouncedStellarIncentiveParams,
  GetAnnouncedStellarIncentiveParams,
  CreateStellarCourseParams,
  LinkStellarTasksToCourseParams,
  LinkStellarTasksToCourseBody,
  CreateStellarCourseBody,
  ConfirmStellarTasksPayoutBody,
  ConfirmStellarTasksPayoutParams,
} from '@scale/shared/types/stellarGenAITask';
import {
  GetAssignmentDetailsParams,
  GetAssignmentDetailsResponse,
  GetWorkspaceStatusInfoRequest,
  GetWorkspaceStatusInfoResponse,
} from '@scale/shared/sphereEngine/types';
import {
  DeleteLinterRequest,
  DeleteLinterResponse,
  UpdateLinterRequest,
  UpdateLinterResponse,
  AddLintersRequest,
  AddLintersResponse,
  OverwriteLintersResponse,
  OverwriteLintersRequest,
} from '@scale/shared/linters/endpoint';
import _ from 'lodash';
import {
  ModelEvalEndpointWithUserInfoDTO,
  ModelEvalEndpointDTO,
  ModelAvailability,
  ModelResponseAndRequestDTO,
  ModelHealthMetrics,
  ModelErrorBreakdownDTO,
} from '@scale/customer-app-shared';
import { CreateCompletionResponse } from '@scale/shared/types/chat-completion';
import cookies from 'browser-cookies';
/* -----------------------------------------------------------------------------
 * Chat Autorater Response Suggestions Endpoints
 * ----------------------------------------------------------------------------- */
export async function runAutoraterJustificationSuggestions(
  params: AutoraterJustificationSuggestionRequest,
) {
  return await apiFetch<AutoraterJustificationSuggestionsResponse>(
    null,
    `internal/genai/autorater/v0/justification`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function runAutoraterLikertJustificationSuggestions(
  params: AutoraterLikertJustificationSuggestionRequest,
) {
  return await apiFetch<AutoraterLikertJustificationSuggestionsResponse>(
    null,
    `internal/genai/autorater/v0/likert-justification`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}
/* -----------------------------------------------------------------------------
 * Chat Linter Endpoints
 * ----------------------------------------------------------------------------- */
export async function getLinterStats(params: LinterStatsRequest) {
  return await apiFetch<LinterStatsResponse>(null, `internal/genai/linterStats`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

export async function getDowngradedLinters(params: GetDowngradedLintersRequest) {
  return await apiFetch<GetDowngradedLintersResponse>(null, `internal/genai/getDowngradedLinters`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

export async function runMultiReplicaPerStepResponseLinter(
  params: RunMultiReplicaStepResponseLinterRequest,
) {
  return await apiFetch<RunMultiReplicaStepResponseLinterResponse>(
    null,
    `internal/genai/runMultiReplicaPerStepResponseLinter`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function runPerStepResponseLinter(params: RunPerStepResponseLinterRequest) {
  return await apiFetch<RunPerStepResponseLinterResponse>(
    null,
    `internal/genai/runPerStepResponseLinter`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function runResponseLinter(params: RunResponseLinterRequest) {
  return await apiFetch<RunResponseLinterResponse>(null, `internal/genai/runResponseLinter`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

export async function deleteLinter(params: DeleteLinterRequest) {
  // we use apiFetch, which throws an HTTPError if we get a non-200 response
  // so if we get a 200 response, we know it will be of the successful type of response
  return await apiFetch<Extract<DeleteLinterResponse, { success: true }>>(
    null,
    `internal/genai/linters/deleteLinter`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
      passError: true,
    },
  );
}

export async function updateLinter(params: UpdateLinterRequest) {
  return await apiFetch<Extract<UpdateLinterResponse, { success: true }>>(
    null,
    `internal/genai/linters/updateLinter`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
      passError: true,
    },
  );
}

export async function addLinters(params: AddLintersRequest) {
  return await apiFetch<Extract<AddLintersResponse, { success: true }>>(
    null,
    `internal/genai/linters/addLinters`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
      passError: true,
    },
  );
}

/** This is meant to be used **only** when we're saving linters for a project.
 * This replaces the old `updateProjectConfigMutation` for linters, but should not be used elsewhere
 */
export async function overwriteLinters(params: OverwriteLintersRequest) {
  return await apiFetch<Extract<OverwriteLintersResponse, { success: true }>>(
    null,
    `internal/genai/linters/overwriteLinters`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
      passError: true,
    },
  );
}

/* -----------------------------------------------------------------------------
 * Reviewer Copilot Endpoints
 * ----------------------------------------------------------------------------- */
export async function fetchReviewerCopilotInference(params: FetchReviewerCopilotInferenceRequest) {
  return await apiFetch<FetchReviewerCopilotInferenceResponse>(
    null,
    `internal/genai/fetchReviewerCopilotInference`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function sendReviewerCopilotFeedback(params: SendReviewerCopilotFeedbackRequest) {
  return await apiFetch<SendReviewerCopilotFeedbackResponse>(
    null,
    `internal/genai/sendReviewerCopilotFeedback`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

/* -----------------------------------------------------------------------------
 * Chat AutoCritique Endpoints
 * ----------------------------------------------------------------------------- */
export async function autoCritique(params: AutoCritiqueRequest) {
  return await apiFetch<AutoCritiqueResponse>(null, `internal/genai/autoCritique`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

/* -----------------------------------------------------------------------------
 * Ops Hub Endpoints
 * ----------------------------------------------------------------------------- */
export async function updateProjectConfig(params: UpdateProjectConfigRequest) {
  return await apiFetch<UpdateProjectConfigResponse>(
    null,
    `corp-api/corp-project-group-manager/projectConfigs`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function getCustomerModelVersions({
  customerId,
  projectId,
}: {
  customerId?: string;
  projectId?: string;
}) {
  return await apiFetch<ModelEvalEndpointWithUserInfoDTO[]>(
    null,
    `corp-api/corp-project-group-manager/modelManager/modelConfigurations?${
      customerId ? `customerId=${customerId}` : projectId ? `projectId=${projectId}` : ''
    }`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
  );
}

export async function getModelConfigurationById(modelId: string) {
  return await apiFetch<ModelEvalEndpointDTO>(
    null,
    `corp-api/corp-project-group-manager/modelManager/modelConfigurations/model/${modelId}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
  );
}

export async function getModelAvailability(
  modelFamilyOrName: string,
  projectId?: string,
  customerId?: string,
) {
  const encodedModelFamilyOrName = encodeURIComponent(modelFamilyOrName);
  return await apiFetch<ModelAvailability>(
    null,
    `corp-api/corp-project-group-manager/modelManager/modelAvailability/${encodedModelFamilyOrName}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      query: {
        ...(projectId ? { projectId } : {}),
        ...(customerId ? { customerId } : {}),
      },
    },
  );
}

export async function getModelVersionsByProject(projectId: string) {
  return await apiFetch<{ id: string; name: string; versionName: string; removable: boolean }[]>(
    null,
    `corp-api/corp-project-group-manager/modelManager/modelVersionsByProject/${projectId}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
  );
}

export async function removeCustomerProjectModelVersion(
  projectId?: string,
  modelVersionId?: string,
) {
  return await apiFetch<void>(
    null,
    `corp-api/corp-project-group-manager/modelManager/modelVersionsByProject/project/${projectId}/model/${modelVersionId}`,
    { method: 'DELETE' },
  );
}

export async function getModelVersionConfigurationById(modelVersionConfigurationId: string) {
  return await apiFetch<ModelEvalEndpointDTO>(
    null,
    `corp-api/corp-project-group-manager/modelManager/modelConfigurations/model/${modelVersionConfigurationId}`,
    { method: 'GET' },
  );
}

export async function getModelLogs({
  modelVersionIdOrVersionOrFamily,
  page,
  pageSize,
  search,
  status,
  projectId,
  useCase,
}: {
  modelVersionIdOrVersionOrFamily?: string;
  page?: number;
  pageSize?: number;
  search?: string;
  status?: string;
  projectId?: string;
  useCase?: string;
}) {
  const url = modelVersionIdOrVersionOrFamily
    ? `corp-api/corp-project-group-manager/modelManager/modelLogs/${modelVersionIdOrVersionOrFamily}`
    : `corp-api/corp-project-group-manager/modelManager/modelLogs`;
  return await apiFetch<ModelResponseAndRequestDTO[]>(null, url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    query: {
      ...(page ? { page } : {}),
      ...(pageSize ? { pageSize } : {}),
      ...(search ? { search } : {}),
      ...(status ? { status } : {}),
      ...(projectId ? { projectId } : {}),
      ...(useCase ? { useCase } : {}),
    },
  });
}

export async function getModelLogsCount({
  modelVersionIdOrVersionOrFamily,
  search,
  status,
  projectId,
  useCase,
}: {
  modelVersionIdOrVersionOrFamily?: string;
  search?: string;
  status?: string;
  projectId?: string;
  useCase?: string;
}) {
  const url = modelVersionIdOrVersionOrFamily
    ? `corp-api/corp-project-group-manager/modelManager/modelLogsCount/${modelVersionIdOrVersionOrFamily}`
    : `corp-api/corp-project-group-manager/modelManager/modelLogsCount`;
  return await apiFetch<number>(null, url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    query: {
      ...(search ? { search } : {}),
      ...(status ? { status } : {}),
      ...(projectId ? { projectId } : {}),
      ...(useCase ? { useCase } : {}),
    },
  });
}

export async function replayModelRequest(requestId: string) {
  return await apiFetch<CreateCompletionResponse>(
    null,
    `corp-api/corp-project-group-manager/modelManager/replayModelRequest`,
    {
      method: 'POST',
      body: { requestId },
    },
  );
}

export async function getModelVersionHealth(
  modelVersionConfigurationIdOrModelFamily: string,
  startTime: number,
  endTime: number,
  periodMinutes: number,
) {
  return await apiFetch<ModelHealthMetrics>(
    null,
    `corp-api/corp-project-group-manager/modelManager/modelVersionHealth/${modelVersionConfigurationIdOrModelFamily}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      query: {
        startTime,
        endTime,
        periodMinutes,
      },
    },
  );
}

interface ModelHealthAgentEvent {
  status: 'started' | 'completed' | 'error';
  message?: string;
  data?: any;
  error?: string;
}

export async function runModelHealthAgent(
  modelName: string,
  projectId: string,
  forceRefresh?: boolean,
): Promise<any> {
  return new Promise((resolve, reject) => {
    // Use apiFetch to get proper authentication and then use the response for SSE
    const body = JSON.stringify({
      modelName,
      projectId,
      ...(forceRefresh ? { forceRefresh } : {}),
    });

    authFetch(null, `/corp-api/tooling-agent/run-model-health-agent`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': cookies.get('_csrf') ?? 'blank',
      },
      body,
    })
      .then(async (response: any) => {
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
        }

        const reader = response.body?.getReader();
        const decoder = new TextDecoder();

        if (!reader) {
          throw new Error('Response body is not readable');
        }

        const readStream = async (): Promise<void> => {
          try {
            const { done, value } = await reader.read();

            if (done) {
              return;
            }

            const chunk = decoder.decode(value, { stream: true });

            // Handle multiple lines in a single chunk
            const lines = chunk.split('\n');

            for (const line of lines) {
              const trimmedLine = line.trim();
              if (trimmedLine.startsWith('data: ')) {
                try {
                  const eventData: ModelHealthAgentEvent = JSON.parse(trimmedLine.slice(6));
                  switch (eventData.status) {
                    case 'completed':
                      resolve(eventData.data);
                      return;
                    case 'error':
                      reject(new Error(eventData.error || 'Agent execution failed'));
                      return;
                  }
                } catch (parseError) {
                  reject(new Error(`Failed to parse event data: ${parseError}`));
                }
              }
            }

            await readStream();
          } catch (error: any) {
            reject(error);
          }
        };

        return readStream();
      })
      .catch(error => {
        const errorMessage = error instanceof Error ? error.message : 'Request failed';
        reject(new Error(errorMessage));
      });
  });
}

export async function analyzeModelErrors(
  errorLogs: any[],
  projectId: string,
  searchQuery?: string,
): Promise<any> {
  return await apiFetch<any>(null, `/corp-api/tooling-agent/analyze-model-errors`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      errorLogs,
      projectId,
      searchQuery,
    }),
  });
}

export async function getModelErrorBreakdown(
  modelVersionIdOrVersionOrFamily?: string,
  projectId?: string,
  startTime?: number,
  useCase?: string,
) {
  return await apiFetch<ModelErrorBreakdownDTO>(
    null,
    `corp-api/corp-project-group-manager/modelManager/modelErrorBreakdown`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      query: {
        ...(modelVersionIdOrVersionOrFamily ? { modelVersionIdOrVersionOrFamily } : {}),
        ...(projectId ? { projectId } : {}),
        ...(startTime ? { startTime } : {}),
        ...(useCase ? { useCase } : {}),
      },
    },
  );
}

/* -----------------------------------------------------------------------------
 * Contributor Feedback Endpoints
 * ----------------------------------------------------------------------------- */

export async function fetchContributorFeedbackForStep(
  params: FetchContributorFeedbackForStepRequest,
) {
  return await apiFetch<FetchContributorFeedbackForStepResponse>(
    null,
    `internal/genai/fetchContributorFeedbackForStep`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function fetchContributorFeedbackForAttempt(
  params: FetchContributorFeedbackForAttemptRequest,
) {
  return await apiFetch<FetchContributorFeedbackForAttemptResponse>(
    null,
    `internal/genai/fetchContributorFeedbackForAttempt`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

/* -----------------------------------------------------------------------------
 * Chat Feedback Endpoints
 * ----------------------------------------------------------------------------- */
export async function fetchWorkerComments(params: FetchWorkerCommentsRequest) {
  return await apiFetch<FetchWorkerCommentsResponse>(null, `internal/genai/fetchWorkerComments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

export async function fetchWorkerCommentsForTaskAttempt(
  params: FetchWorkerCommentsForTaskAttemptRequest,
) {
  return await apiFetch<FetchWorkerCommentsForTaskAttemptResponse>(
    null,
    `internal/genai/fetchWorkerComments/taskAttempt`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function addWorkerComment(params: AddWorkerCommentRequest) {
  return await apiFetch<AddWorkerCommentResponse>(null, `internal/genai/addWorkerComment`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

export async function bulkAddWorkerComments(params: BulkAddWorkerCommentsRequest) {
  return await apiFetch<BulkAddWorkerCommentsResponse>(
    null,
    `internal/genai/bulkAddWorkerComments`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function addFeedbackToWorkerComment(params: AddFeedbackToWorkerCommentRequest) {
  return await apiFetch<AddFeedbackToWorkerCommentResponse>(
    null,
    `internal/genai/addFeedbackToWorkerComment`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function bulkAddFeedbackToWorkerComments(
  params: BulkAddFeedbackToWorkerCommentsRequest,
) {
  return await apiFetch<BulkAddFeedbackToWorkerCommentsResponse>(
    null,
    `internal/genai/bulkAddFeedbackToWorkerComments`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

/* -----------------------------------------------------------------------------
 * Attempt Feedback Endpoints
 * ----------------------------------------------------------------------------- */

export async function addAttemptFeedback(params: AddAttemptFeedbackRequest) {
  return await apiFetch<AddAttemptFeedbackResponse>(null, `internal/genai/addAttemptFeedback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

export async function fetchAttemptFeedback(params: FetchAttemptFeedbackRequest) {
  return await apiFetch<FetchAttemptFeedbackResponse>(null, `internal/genai/fetchAttemptFeedback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

/* -----------------------------------------------------------------------------
 * Screening Endpoints
 * ----------------------------------------------------------------------------- */
export async function fetchPendingScreening(params: ScreeningPendingReviewRequest) {
  return await apiFetch<ScreeningPendingReviewResponse>(
    null,
    `internal/genai/fetchPendingScreening`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function reviewScreeningWithScore(params: ReviewScreeningWithScoreRequest) {
  return await apiFetch<ReviewScreeningWithScoreResponse>(
    null,
    `internal/genai/reviewScreeningWithScore`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function publishScreeningBenchmark(params: PublishScreeningBenchmarkRequest) {
  return await apiFetch<PublishScreeningBenchmarkResponse>(
    null,
    `internal/genai/publishScreeningBenchmark`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function publishBulkScreeningBenchmark(params: PublishBulkScreeningBenchmarkRequest) {
  return await apiFetch<PublishBulkScreeningBenchmarkResponse>(
    null,
    `internal/genai/publishBulkScreeningBenchmark`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function fetchScreeningBenchmarkData(params: FetchScreeningBenchmarkRequest) {
  return await apiFetch<FetchScreeningBenchmarkResponse>(
    null,
    `internal/genai/fetchScreeningBenchmarkData`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function updateScreeningBenchmarkEnabled(
  params: UpdateScreeningBenchmarkEnabledRequest,
) {
  return await apiFetch<UpdateScreeningBenchmarkEnabledResponse>(
    null,
    `internal/genai/updateScreeningBenchmarkEnabled`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function fetchAuditorEvaluationData(params: FetchAuditorEvaluationRequest) {
  return await apiFetch<FetchAuditorEvaluationResponse>(
    null,
    `internal/genai/fetchAuditorEvaluationData`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function publishAuditPermissionRole(params: PublishAuditPermissionRoleRequest) {
  return await apiFetch<PublishAuditPermissionRoleResponse>(
    null,
    `internal/genai/publishAuditPermissionRole`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function updateAuditPermissionRole(params: UpdateAuditPermissionRoleRequest) {
  return await apiFetch<PublishAuditPermissionRoleResponse>(
    null,
    `internal/genai/updateAuditPermissionRole`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function archiveAuditPermissionRole(params: ArchiveAuditPermissionRoleRequest) {
  return await apiFetch<ArchiveAuditPermissionRoleResponse>(
    null,
    `internal/genai/archiveAuditPermissionRole`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function fetchAuditPermissions(params: FetchAuditPermissionsRequest) {
  return await apiFetch<FetchAuditPermissionsResponse>(
    null,
    `internal/genai/fetchAuditPermissions`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function updateAuditorPermissions(params: UpdateAuditorPermissionsRequest) {
  return await apiFetch<UpdateAuditorPermissionsResponse>(
    null,
    `internal/genai/updateAuditorPermissions`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function updatePermissionFilters(params: UpdatePermissionFiltersRequest) {
  return await apiFetch<UpdatePermissionFiltersResponse>(
    null,
    `internal/genai/updatePermissionFilters`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function updatePermissionBenchmarkSettings(
  params: UpdatePermissionBenchmarkSettingsRequest,
) {
  return await apiFetch<UpdatePermissionBenchmarkSettingsResponse>(
    null,
    `internal/genai/updatePermissionBenchmarkSettings`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function fetchScreeningBenchmarkPermissionsInfo(
  params: FetchScreeningBenchmarkPermissionsInfoRequest,
) {
  return await apiFetch<FetchScreeningBenchmarkPermissionsInfoResponse>(
    null,
    `internal/genai/fetchScreeningBenchmarkPermissionsInfo`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function updateBenchmarkPermissions(
  params: UpdateScreeningBenchmarkPermissionsRequest,
) {
  return await apiFetch<UpdateScreeningBenchmarkPermissionsResponse>(
    null,
    `internal/genai/updateBenchmarkPermissions`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function purgeScreenings(params: PurgeScreeningsRequest) {
  return await apiFetch<PurgeScreeningsResponse>(null, `internal/genai/purgeScreenings`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

export async function sbqScreenings(params: SbqScreeningsRequest) {
  return await apiFetch<SbqScreeningsResponse>(null, `internal/genai/sbqScreenings`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

export async function fetchUniqueSectionTitles() {
  return await apiFetch<FetchUniqueSectionTitlesResponse>(
    null,
    `internal/genai/fetchUniqueSectionTitles`,
    {
      method: 'POST',
    },
  );
}

/* -----------------------------------------------------------------------------
 * Corp Dialogue Endpoints
 * ----------------------------------------------------------------------------- */
export async function saveCorpDialogue(params: SaveCorpDialogueRequest) {
  return await apiFetch<SaveCorpDialogueResponse>(null, `internal/genai/saveCorpDialogue`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

export async function fetchCorpDialogues(options?: ApiFetchOptions) {
  return await apiFetch<FetchCorpDialoguesResponse>(null, `internal/genai/fetchCorpDialogues`, {
    ...options,
    method: 'POST',
  });
}

export async function updateCorpDialogue(params: UpdateCorpDialogueRequest) {
  return await apiFetch<UpdateCorpDialogueResponse>(null, `internal/genai/updateCorpDialogue`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

export async function deleteCorpDialogue(params: DeleteCorpDialogueRequest) {
  return await apiFetch<DeleteCorpDialogueResponse>(null, `internal/genai/deleteCorpDialogue`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

/* -----------------------------------------------------------------------------
 * Benchmarks Endpoints
 * ----------------------------------------------------------------------------- */
export async function fetchBenchmarkCandidates(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch<BulkBenchmarkCandidateResponse>(
    null,
    `corp-api/qm/benchmark-data-bank/benchmark-candidate`,
    {
      method: 'GET',
      query,
    },
  );
}

export async function createBenchmarkCandidate(params: $FIXME) {
  return await apiFetch<BenchmarkCandidateResponse>(
    null,
    `corp-api/qm/benchmark-data-bank/benchmark-candidate`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function bulkCreateBenchmarkCandidate(params: $FIXME) {
  return await apiFetch<BulkBenchmarkCandidateResponse>(
    null,
    `corp-api/qm/benchmark-data-bank/benchmark-candidate/bulk-create`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function updateBenchmarkCandidate(benchmarkCandidateId: string, params: $FIXME) {
  return await apiFetch<BenchmarkCandidateResponse>(
    null,
    `corp-api/qm/benchmark-data-bank/benchmark-candidate/${benchmarkCandidateId}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

export async function bulkUpdateBenchmarkCandidate(params: $FIXME) {
  return await apiFetch<BenchmarkCandidateResponse>(
    null,
    `corp-api/qm/benchmark-data-bank/benchmark-candidate/bulk-approve`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    },
  );
}

/* -----------------------------------------------------------------------------
 * Sphere Engine Endpoints
 * ----------------------------------------------------------------------------- */
const sphereEngineRoute = 'internal/genai';
export async function getAssignmentDetails(params: GetAssignmentDetailsParams) {
  return await apiFetch<GetAssignmentDetailsResponse>(
    null,
    sphereEngineRoute + `/getAssignmentDetails/${params.assignmentId}`,
    {
      method: 'GET',
    },
  );
}

export async function getWorkspaceStatusInfo(params: GetWorkspaceStatusInfoRequest) {
  return await apiFetch<GetWorkspaceStatusInfoResponse>(
    null,
    sphereEngineRoute + `/getWorkspaceStatusInfo/${params.projectId}`,
    {
      method: 'GET',
    },
  );
}

/* -----------------------------------------------------------------------------
 * Stellar Tasks Endpoints
 * ----------------------------------------------------------------------------- */
const stellarTasksRoute = 'internal/genai/stellarTasks';
export async function getStellarGenAITasksByProject(
  params: GetStellarGenAITasksByProjectParams,
  query?: GetStellarGenAITasksByProjectQuery,
) {
  return await apiFetch<GetStellarGenAITasksByProjectRespBody>(
    null,
    stellarTasksRoute + `/project/${params.projectId}`,
    {
      method: 'GET',
      query,
    },
  );
}

export async function getStellarGenAITaskByAttempt(params: GetStellarGenAITaskByAttemptParams) {
  return await apiFetch<GetStellarGenAITaskByAttemptRespBody>(
    null,
    stellarTasksRoute + `/taskAttempt/${params.taskAttemptId}`,
    {
      method: 'GET',
    },
  );
}

export async function getStellarGenAITaskEligibility(params: GetStellarGenAITaskEligibilityParams) {
  return await apiFetch<GetStellarGenAITaskEligibilityRespBody>(
    null,
    stellarTasksRoute + `/taskAttempt/${params.taskAttemptId}/eligibility`,
    {
      method: 'GET',
    },
  );
}

export async function createStellarGenAITask(body: CreateStellarGenAITaskReqBody) {
  return await apiFetch<CreateStellarGenAITaskRespBody>(null, stellarTasksRoute + `/`, {
    method: 'POST',
    body,
  });
}

export async function updateStellarGenAITask(
  params: UpdateStellarGenAITaskParams,
  body: UpdateStellarGenAITaskReqBody,
) {
  return await apiFetch<UpdateStellarGenAITaskRespBody>(
    null,
    stellarTasksRoute + `/${params.stellarTaskId}`,
    {
      method: 'PATCH',
      body,
    },
  );
}

export async function setAnnouncedStellarIncentive(params: SetAnnouncedStellarIncentiveParams) {
  return await apiFetch(
    null,
    stellarTasksRoute + `/stellar-quality-ops-hub/${params.projectId}/announced-incentive`,
    { method: 'POST' },
  );
}

export async function getAnnouncedStellarIncentive(params: GetAnnouncedStellarIncentiveParams) {
  return await apiFetch(
    null,
    stellarTasksRoute + `/stellar-quality-ops-hub/${params.projectId}/get-announced-incentive`,
    { method: 'GET' },
  );
}

export async function linkStellarTasksToCourse(
  params: LinkStellarTasksToCourseParams,
  body: LinkStellarTasksToCourseBody,
) {
  return await apiFetch(
    null,
    stellarTasksRoute + `/stellar-quality-ops-hub/${params.projectId}/link-stellar-tasks-to-course`,
    { method: 'POST', body },
  );
}

export async function confirmStellarTasksPayout(
  params: ConfirmStellarTasksPayoutParams,
  body: ConfirmStellarTasksPayoutBody,
) {
  return await apiFetch(
    null,
    stellarTasksRoute + `/stellar-quality-ops-hub/${params.projectId}/confirm-stellar-tasks-payout`,
    { method: 'POST', body },
  );
}

export async function createStellarCourse(
  params: CreateStellarCourseParams,
  body: CreateStellarCourseBody,
) {
  return await apiFetch(
    null,
    stellarTasksRoute + `/stellar-quality-ops-hub/${params.projectId}/create-stellar-course`,
    { method: 'POST', body },
  );
}

export async function generateUnitTests(body: GenerateUnitTestsRequest) {
  return await apiFetch<GenerateUnitTestsResponse>(null, `internal/genai/generateUnitTests`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function runUnitTests(body: RunUnitTestsRequest) {
  return await apiFetch<RunUnitTestsResponse>(null, `internal/genai/runUnitTests`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function getHiddenUnitTestsFromTaskMetadata(
  body: GetHiddenUnitTestsFromTaskMetadataRequest,
) {
  return await apiFetch<GetHiddenUnitTestsFromTaskMetadataResponse>(
    null,
    `internal/genai/getHiddenUnitTestsFromTaskMetadata`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
}
